import { useGetCartQuery } from "@/redux/features/api/cart/cartApiSlice";

const useDataOrderSection = () => {
    const { data: cartData, error, isLoading } = useGetCartQuery<any>({});
    return { cartData: cartData?.data?.cart?.itemsCart, totalPrice: cartData?.data?.cart?.totalPrice, currency: cartData?.data?.cart?.currency,  error: error?.data?.error?.message as string, isLoadingCart: isLoading };
}

export default useDataOrderSection;